import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { EdgerRoll, EdgerRollPassResponse } from "../models/EdgerRoll";

export const getEdgerRolls = async (
	params: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.partId) parameters.push({ name: "PartId", value: params.partId });

	const resp = await apiService.callV2(
		"[M2].[GetEdgerRolls]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as EdgerRoll[];
	} else {
		throw new Error(resp.message || "Error fetching arbors");
	}
};
export const upsertEdgerRoll = async (roll: EdgerRoll) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "PartId", value: roll.PartId },
		{ name: "PartName", value: roll.PartName },
		{ name: "LocationId", value: roll.LocationId },
		{ name: "StandId", value: roll.StandId },
		{ name: "Comments", value: roll.Comments },
		{ name: "RollPosition", value: roll.RollPosition },
		{ name: "RollStatusCode", value: roll.RollStatusCode },
		{ name: "Diameter", value: roll.Diameter ? Number(roll.Diameter) : null },
		{
			name: "NewDiameter",
			value: roll.NewDiameter ? Number(roll.NewDiameter) : null,
		},
		{
			name: "ScrapDiameter",
			value: roll.ScrapDiameter ? Number(roll.ScrapDiameter) : null,
		},
		{ name: "RollsetLetter", value: roll.RollsetLetter },
	];

	const resp = await apiService.callV2("[M2].[UpsertEdgerRoll]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting roll");
	}
};

export const deleteEdgerRoll = async (partIds: string | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartIds", value: partIds }];

	const resp = await apiService.callV2("[M2].[DeleteRoll]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting roll");
	}
};

export const getEdgerRollPasses = async (
	params: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.partId) parameters.push({ name: "PartId", value: params.partId });

	const resp = await apiService.callV2(
		"[M2].[GetEdgerRollPasses]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as EdgerRollPassResponse[];
	} else {
		throw new Error(resp.message || "Error fetching arbors");
	}
};

export const upsertEdgerRollPass = async ({
	status,
	passNumber,
	partId,
	sectionIds,
	isDiagonal,
	isDiagonalForAll,
}: {
	status?: string;
	passNumber?: number;
	partId: number;
	sectionIds?: string;
	isDiagonal?: boolean;
	isDiagonalForAll?: boolean;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartId", value: partId }];

	if (passNumber) parameters.push({ name: "PassNumber", value: passNumber });
	if (status) parameters.push({ name: "PassStatusCode", value: status });
	if (sectionIds != undefined)
		parameters.push({ name: "SectionIdCSV", value: sectionIds });
	if (isDiagonal !== undefined)
		parameters.push({
			name: "IsDiagonal",
			value: isDiagonal,
		});
	if (isDiagonalForAll !== undefined)
		parameters.push({
			name: "IsDiagonalForAll",
			value: isDiagonalForAll,
		});

	const resp = await apiService.callV2(
		"[M2].[UpsertEdgerRollPass]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting edger roll pass");
	}
};

export const deleteEdgerRollPass = async ({ partId }: { partId: number }) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartId", value: partId }];

	const resp = await apiService.callV2(
		"[M2].[DeleteEdgerRollPass]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting edger roll pass");
	}
};
